// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// Asset Imports
// Bootstrap Imports
import { DifferenceQuote, TermSelect } from './'

export default function QuoteInfoRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['DifferenceQuote']
   const { getFormattedString } = state

   if (state.user_view == 'External') {
      return (
         <div className='row pb-3'>
            <div className='col col_bhr_nowrap'>
               {getFormattedString('product.QuoteInfoRow.AccountName', {
                  accountName: state.account_name,
               })}
            </div>
            <div className='col'></div>
            <div className='col'>
               {(permissions.includes(state.user_role) ||
                  state.differenceQuote == true) && <DifferenceQuote />}
            </div>
            <div className='col'>
               <TermSelect />
            </div>
            <div className='col'></div>
            <div className='col col_bhr_nowrap col_bhr_align_right'>
               {getFormattedString('product.QuoteInfoRow.AgentName', {
                  lastAgentName: state.last_agent_name,
               })}
            </div>
         </div>
      )
   }

   return null
}
